<template>
  <!--活动主页面-->
  <div class="collectbg">
    <div class="coll-integral">
      <img
        class="coll-in-img"
        src="../../assets/images/activity/workshop/integral.png"
      />
      <span class="coll-in-font">{{ totalPointValue }}</span>
      <div class="coll-in-btn">
        <van-button
          type="info"
          size="normal"
          class="btn-exchange"
          @click="goExchange"
          >去兑换</van-button
        >
      </div>
    </div>
    <div class="coll-row">
      <div class="coll-item coll-one coll-task1">
        <p class="coll-fontone">补全基本信息</p>
        <p class="coll-fonttwo">定期推送超值福利</p>
        <div class="submit-btn">
          <van-button
            v-if="!task1Finished"
            type="info"
            size="normal"
            @click="handleTaskOne"
            >去完成</van-button
          >
          <van-button v-else type="info" size="normal" color="rgb(213,214,216)"
            >已完成</van-button
          >
        </div>
      </div>
      <div class="coll-item coll-task2">
        <p class="coll-fontone">上传门头照</p>
        <p class="coll-fonttwo task2font">优质照片可获<br/>早餐机一台</p>
        <div class="submit-btn">
          <van-button
            v-if="task2NotFinished"
            type="info"
            size="normal"
            @click="handleTaskTwo"
            >{{ task2StatusName }}</van-button
          >
          <van-button v-else type="info" size="normal" color="rgb(213,214,216)"
            >{{ task2StatusName }}</van-button
          >
        </div>
      </div>
    </div>
    <div class="coll-row coll-row-two">
      <div class="coll-item coll-one coll-task3">
        <p class="coll-fontone">玩游戏赚积分</p>
        <p class="coll-fonttwo task2font">8组博世易损件拼手速</p>
        <div class="submit-btn">
          <van-button
            v-if="!task3Finished"
            type="info"
            size="normal"
            @click="handleTaskThree"
            >去完成</van-button
          >
          <van-button v-else type="info" size="normal" color="rgb(213,214,216)"
            >已完成</van-button
          >
        </div>
      </div>
      <div class="coll-item coll-task4">
        <p class="coll-fontone">有奖问答</p>
        <p class="coll-fonttwo">完成所有任务就能参与抽大奖活动</p>
        <div class="submit-btn">
          <van-button
            v-if="!task4Finished"
            type="info"
            size="normal"
            @click="handleTaskFour"
            >去完成</van-button
          >
          <van-button v-else type="info" size="normal" color="rgb(213,214,216)"
            >已完成</van-button
          >
        </div>
      </div>
    </div>
    <div class="coll-remarks">
      <p class="desc-head">活动说明</p>
      <div class="desc-text">
        <p class="ptext">1. 活动时间：2021年5月19日-9月19日；</p>
        <p class="ptext">2. 用户完成任务可获得对应易加积分；</p>
        <p class="ptext">
          3.
          上传真实门头照，通过人工审核后将评选出10家“优质店面”，每位可获得摩飞早餐机一台；
        </p>
        <p class="ptext">
          4.
          完成所有任务的用户在通过人工审核后，可参与当月幸运抽奖，奖品为苹果iPad mini一台，若当月未中奖可继续参与次月抽奖，最多可有4次抽奖机会。（奖品总数为10台)；
        </p>
        <p class="ptext">
          5. 每个任务一旦提交后可获得积分奖励，已提交内容不可修改；
        </p>
        <p class="ptext">
          6. 奖励积分实时到账，实物礼品将在活动结束且公示后2个工作日内发出；
        </p>
        <p class="ptext">
          7. 具体抽奖信息会在易加网微信公众号上公示，请实时关注；
        </p>
        <p class="ptext">
          8. 本活动最终解释权归博世易加所有，如有疑问请咨询客服。
        </p>
      </div>
    </div>
    <Game ref="task3Game" @onSubmit="handleTask3Submit()" />
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import Game from './activity-workshop-game'

export default {
  name: 'ActivityWorkshopCollect',
  components: {
    Game
  },
  data () {
    return {
      totalPointValue: 0,
      task1: {},
      task2: {},
      task3: {},
      task4: {}
    }
  },
  mounted () {
    this.queryIntegral()
  },
  computed: {
    task1Finished () {
      return !!this.task1.task1SubmitTime
    },
    task2NotFinished () {
      return !this.task2.task2SubmitTime || this.task2.task2VerifyStatus === 2
    },
    task2Submitted () {
      return !!this.task2.task2SubmitTime
    },
    task3Finished () {
      return !!this.task3.task3SubmitTime
    },
    task4Finished () {
      return !!this.task4.task4SubmitTime
    },
    task2StatusName () {
      if (!this.task2.task2SubmitTime) {
        return '去完成'
      } else if (this.task2.task2VerifyStatus === 1) {
        return '已完成'
      } else if (this.task2.task2VerifyStatus === 0) {
        return '待审核'
      } else if (this.task2.task2VerifyStatus === 2) {
        return '去修改'
      } else {
        return '去完成'
      }
    }
  },
  methods: {
    goExchange () {
      document.location = process.env.VUE_APP_EXTRA_SITE + '/#/goodsGifts'
    },
    // 获取积分、任务状态
    queryIntegral () {
      this.$toast.loading({
        message: '查询数据',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi
        .workshopCollect()
        .then((response) => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            this.totalPointValue = response.data.resultData.collectInfo.totalPointValue || 0
            this.task1 = response.data.resultData.collectInfo.task1 || {}
            this.task2 = response.data.resultData.collectInfo.task2 || {}
            this.task3 = response.data.resultData.collectInfo.task3 || {}
            this.task4 = response.data.resultData.collectInfo.task4 || {}
          } else {
            this.$toast.loading({
              type: 'fail',
              duration: 1000,
              message: response.data.resultMsg
            })
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    // 任务一 基本信息页面
    handleTaskOne () {
      this.$router.push('/activity/activity-workshop-information')
    },
    // 任务二 上传门头照
    handleTaskTwo () {
      if (!this.task1Finished) {
        this.showFinishPreTask()
        return
      }
      if (!this.task2NotFinished) {
        return
      }
      this.$router.push('/activity/activity-workshop-photo')
    },
    // 任务三 玩游戏赚积分
    handleTaskThree () {
      if (!this.task2Submitted) {
        this.showFinishPreTask()
        return
      }
      if (this.task3Finished) {
        return
      }
      this.$refs.task3Game.show()
    },
    handleTask3Submit () {
      this.queryIntegral()
    },
    // 任务四 有奖问答
    handleTaskFour () {
      if (!this.task3Finished) {
        this.showFinishPreTask()
        return
      }
      if (this.task4Finished) {
        return
      }
      this.$router.push('/activity/activity-workshop-question')
    },
    showFinishPreTask () {
      this.$toast.loading({
        type: 'fail',
        duration: 1000,
        message: '请先完成上一个任务'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.collectbg {
  position: relative;
  width: 100%;
  height: 900px;
  padding-bottom: 40px;
  background-image: url("../../assets/images/activity/workshop/collectbg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #fafafa;
  .coll-row-two {
    margin-top: 163px;
  }
  .coll-task1 {
    background-image: url("../../assets/images/activity/workshop/task1.png");
  }
  .coll-task2 {
    background-image: url("../../assets/images/activity/workshop/task2.png");
  }
  .coll-task3 {
    background-image: url("../../assets/images/activity/workshop/task3.png");
  }
  .coll-task4 {
    background-image: url("../../assets/images/activity/workshop/task4.png");
  }
  .coll-fontone {
    position: absolute;
    top: 78px;
    font-size: 13px;
    font-weight: 700;
    left: 30px;
    right: 30px;
    text-align: center;
    color: rgb(51, 51, 51);
  }
  .coll-fonttwo {
    position: absolute;
    top: 98px;
    left: 25px;
    right: 25px;
    font-size: 11px;
    line-height: 14px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  .task2font {
    position: absolute;
    top: 98px;
    left: 10px;
    right: 8px;
  }
  .coll-integral {
    position: absolute;
    width: 300px;
    height: 30px;
    top: 227px;
    left: 50%;
    transform: translateX(-50%);
    line-height: 28px;
    .coll-in-img {
      width: 98px;
      height: 15px;
      margin: auto 0;
      margin-right: 20px;
    }
    .coll-in-font {
      text-decoration: underline;
      font-size: 28px;
      color: rgb(227, 106, 91);
      text-decoration-color: rgb(227, 106, 91);
    }
    .coll-in-btn {
      position: absolute;
      right: 0px;
      bottom: 0px;
      display: inline-block;
      .btn-exchange {
        width: 100%;
        height: 24px;
        line-height: 24px;
        border: solid 2px rgb(227, 106, 91);
        background-color: unset;
        border-radius: 5px;
        .van-button__text {
          font-size: 10px;
          color: rgb(227, 106, 91);
        }
      }
    }
  }
  .coll-row {
    position: absolute;
    height: 150px;
    top: 275px;
    left: 28px;
    right: 28px;
    .coll-item {
      position: relative;
      width: 149px;
      height: 150px;
      display: inline-block;
      background-size: 100% 100%;
    }
    .coll-one {
      margin-right: 21px;
    }
  }
  .submit-btn {
    position: absolute;
    bottom: 0px;
    left: 27px;
    right: 30px;
    text-align: center;
    .van-button {
      width: 80%;
      height: 20px;
      line-height: 24px;
      background: rgb(227, 106, 91);
      border: none;
      border-radius: 5px 5px 0 0;
      .van-button__text {
        font-size: 14px;
      }
    }
  }
  .coll-remarks {
    position: absolute;
    width: 324px;
    height: 276px;
    top: 606px;
    bottom: 19px;
    left: 50%;
    transform: translateX(-50%);
    .desc-head {
      color: rgb(102, 102, 102);
      font-size: 18px;
      text-align: center;
      margin-bottom: 10px;
    }
    .desc-text {
      color: rgb(102, 102, 102);
      font-size: 12px;
      letter-spacing: 1px;
      text-align: left;
      .ptext {
        margin-bottom: 2px;
        line-height: 18px;
      }
    }
  }
  .mask {
    width: 100%;
    height: 100%;
  }
}
</style>
